module.exports = __webpack_public_path__ + "static/media/Frogadier_gaussian2.1ddad720.png";